import { cn } from '@/shared/utils/cn'
import { Icon } from '@/shared/ui/Icon'
import type { User } from '../types'

interface Props {
  user: User
  onClick?: () => void
  /** When true, render only the avatar (used in the collapsed sidebar rail). */
  compact?: boolean
}

export function UserProfileCard({ user, onClick, compact = false }: Props) {
  return (
    <button
      type="button"
      className={cn('user-profile', { compact })}
      title={compact ? `${user.fullName} · ${user.role}` : 'Abrir configurações'}
      aria-label={`${user.fullName} — ${user.role}`}
      onClick={onClick}
    >
      <span className="avatar" aria-hidden="true">{user.initials}</span>
      {!compact && (
        <>
          <span className="user-meta">
            <span className="user-name">{user.fullName}</span>
            <span className="user-role">{user.role}</span>
          </span>
          <span className="profile-action" aria-hidden="true">
            <Icon name="settings" />
          </span>
        </>
      )}
    </button>
  )
}
